import { render } from "./modal_transformation.vue?vue&type=template&id=09aaa8cf&scoped=true"
import script from "./modal_transformation.vue?vue&type=script&lang=js"
export * from "./modal_transformation.vue?vue&type=script&lang=js"

import "./modal_transformation.vue?vue&type=style&index=0&id=09aaa8cf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09aaa8cf"]])

export default __exports__